import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router-dom';

import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';

import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import PopupMenu from './popupmenu';
import DataContext from '../data/data-context.js';

const useStyles = makeStyles(theme => ({
    root: {
        flex: '1 1 100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'left',
        alignItems: 'left',
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    nowrap: {
        width: '100%',
        // maxWidth: 700,
        '& .MuiButton-label': {
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textAlign: 'left',
            display: 'block'
        }
    },
}));

const BTJobName = (props) => {
    const classes = useStyles();
    const { backtestingJobsLite } = useContext(DataContext);

    const job = backtestingJobsLite[props.uuid];

    return (
        <span className={classes.root}>
            {job ? (job.name || job.uuid) : props.uuid || ''}
        </span>
    );
};
BTJobName.propTypes = {
    uuid: PropTypes.string,
};

const BTJob = props => {
    const classes = useStyles();
    const { backtestingJobsLite } = useContext(DataContext);
    const navigate = useNavigate();

    const job = backtestingJobsLite[props.uuid] || {};

    const handleOnJobClick = () => {
        navigate('/views/backtesting', { replace: true, state: { job: job.uuid } });
    };

    return (
        <Chip
            label={job.name || 'Unknown Job'}
            className={classes.chip}
            size="small"
            variant="outlined"
            color="default"
            onClick={handleOnJobClick}/>
    );
};
BTJob.propTypes = {
    uuid: PropTypes.string,
};

const BTJobSelector = ({ selection, onSelect }) => {
    const classes = useStyles();
    const { backtestingJobsLite } = useContext(DataContext);
    const [jobs, setJobs] = useState([]);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        setJobs(Object
            .values(backtestingJobsLite || {})
            .sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1));
    }, [backtestingJobsLite]);

    const handleSelect = sel => {
        if (!sel || !sel.uuid) return;

        const _selection = [...selection].filter(s => backtestingJobsLite[s]);
        const i = (_selection || []).findIndex(s => s === sel.uuid);
        if (i >= 0) {
            _selection.splice(i, 1);
        } else {
            _selection.push(sel.uuid);
        }
        onSelect(_selection);
    };

    return (
        <div className={classes.root}>
            <PopupMenu
                multiple
                tooltip="save filter"
                items={jobs || []}
                itemkey="uuid"
                itemTitle="name"
                onSelect={handleSelect}
                title="Jobs"
                onOpen={setOpen}
                button={<Button
                    id="openMenu"
                    variant="text"
                    endIcon={ open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon/>}
                    className={classes.nowrap}> Jobs
                </Button>}
                placement={'bottom-start'}
                selection={selection}
                getInfo={j => j.description}/>
        </div>
    );
};
BTJobSelector.propTypes = {
    selection: PropTypes.array,
    onSelect: PropTypes.func,
};

export {
    BTJobName as default,
    BTJob,
    BTJobSelector,
};
